import { Link } from 'react-router-dom';
import ThemeToggle from '../components/ThemeToggle';
import Footer from '../components/Footer';
import logoImage from '../assets/babysit_logo.png';

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-pink-50 dark:from-gray-900 dark:to-gray-800">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <Link to="/" className="flex flex-col items-center justify-center mb-8 hover:opacity-80 transition-opacity">
            <img 
              src={logoImage} 
              alt="Nannity Logo" 
              className="h-16 sm:h-20 w-auto mb-4"
            />
            <span className="text-2xl sm:text-3xl font-bold gradient-bg bg-clip-text text-transparent">
              Nannity
            </span>
          </Link>

          <div className="card">
            <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-gray-900 dark:text-gray-100">
              Uslovi Korišćenja
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-8">
              Poslednje ažuriranje: {new Date().toLocaleDateString('sr-RS')}
            </p>

            <div className="prose prose-lg dark:prose-invert max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  1. Prihvatanje Uslova
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Dobrodošli u Nannity. Korišćenjem naše platforme, prihvatate ove uslove korišćenja. 
                  Ako se ne slažete sa bilo kojim delom ovih uslova, molimo vas da ne koristite našu uslugu.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  2. Opis Usluge
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Nannity je platforma koja omogućava roditeljima i dadiljama da prate radno vreme, 
                  upravljaju poslovima i komuniciraju. Pružamo različite planove usluga sa različitim funkcionalnostima.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  3. Registracija i Nalog
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Da biste koristili našu platformu, potrebno je da kreiramo nalog. Obavezujete se da ćete:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300 ml-4">
                  <li>Pružiti tačne i potpune informacije</li>
                  <li>Održavati sigurnost vašeg naloga</li>
                  <li>Biti odgovorni za sve aktivnosti koje se dešavaju na vašem nalogu</li>
                  <li>Obavestiti nas odmah o bilo kojoj neovlašćenoj upotrebi</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  4. Plaćanje i Pretplate
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Neki planovi usluga zahtevaju mesečnu pretplatu. Plaćanja se obrađuju sigurno kroz naše 
                  procesore plaćanja. Možete otkazati pretplatu u bilo kom trenutku.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  5. Intelektualna Svojina
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Sav sadržaj na platformi, uključujući logotipe, dizajn, tekst, grafiku i softver, 
                  je vlasništvo Nannity-ja ili naših licencnih davalaca i zaštićen je autorskim pravima.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  6. Zabrana Korišćenja
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Ne smete koristiti našu platformu za:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300 ml-4">
                  <li>Bilo kakve nezakonite aktivnosti</li>
                  <li>Širenje malvera ili virusa</li>
                  <li>Pokušaje pristupa neovlašćenim delovima sistema</li>
                  <li>Kršenje bilo kojih zakona ili propisa</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  7. Odricanje od Odgovornosti
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Platforma se pruža "kakva jeste". Ne garantujemo da će usluga biti neprekidna, bez grešaka 
                  ili bezbedna. Ne snosimo odgovornost za bilo kakve gubitke ili štetu nastalu korišćenjem naše platforme.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  8. Kontakt
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  Ako imate pitanja o ovim uslovima, molimo kontaktirajte nas na: 
                  <a href="mailto:support@mnocompany.com" className="text-primary-600 dark:text-primary-400 hover:underline ml-1">
                    support@mnocompany.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

